import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * App theme: Aura preset with the Material deep-purple palette mapped onto
 * the primary scale, matching the previous Angular Material theme
 * (primary: deep-purple, accent: light-blue).
 */
export const AppTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#EDE7F6',
      100: '#D1C4E9',
      200: '#B39DDB',
      300: '#9575CD',
      400: '#7E57C2',
      500: '#673AB7',
      600: '#5E35B1',
      700: '#512DA8',
      800: '#4527A0',
      900: '#311B92',
      950: '#21136B',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#673AB7',
          contrastColor: '#ffffff',
          hoverColor: '#5E35B1',
          activeColor: '#512DA8',
        },
        highlight: {
          background: '#EDE7F6',
          focusBackground: '#D1C4E9',
          color: '#311B92',
          focusColor: '#311B92',
        },
      },
    },
  },
});
